import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import Login from './views/login'
import Home from './views/home'
import ProcesoCalculo from './views/proceso-calculo'
import AdministradorCodigos from './views/administrador-codigos'
import InventarioGanado from './views/inventario_ganado/inventario_ganado'
import InventarioFinca from './views/inventario_finca/inventario_finca'
import Movimientos from './views/movimientos/movimientos'
import Menu from './components/menu/menu'
import Layout from './components/menu/layout'
import NotFound from './views/not-found'
import ProtectedRoute from './components/ProtectedRoute'
import { LoadingProvider, useLoadingContext } from './components/loading/LoadingProvider'
import LoadingOverlay from './components/loading/LoadingOverlay'
import InstallAppButton from './components/install-app/InstallAppButton'

const AppContent: React.FC = () => {
  const { isLoading } = useLoadingContext();

  return (
    <>
      <Router>
        <Switch>
          <Route component={Login} exact path="/login" />
          <Route component={Home} exact path="/" />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <ProcesoCalculo />
              </Layout>
            )} 
            exact 
            forbiddenForRoles={['admin_finca']}
            path="/proceso-calculo" 
          />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <Menu />
              </Layout>
            )} 
            exact 
            forbiddenForRoles={['admin_finca']}
            path="/menu" 
          />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <AdministradorCodigos />
              </Layout>
            )} 
            exact 
            forbiddenForRoles={['admin_finca']}
            path="/administrador-codigos" 
          />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <InventarioGanado />
              </Layout>
            )} 
            exact 
            forbiddenForRoles={['admin_finca']}
            path="/inventario-ganado" 
          />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <InventarioFinca />
              </Layout>
            )} 
            exact 
            path="/inventario-finca" 
          />
          <ProtectedRoute 
            component={() => (
              <Layout>
                <Movimientos />
              </Layout>
            )} 
            exact 
            forbiddenForRoles={['admin_finca']}
            path="/movimientos" 
          />
          <Route component={NotFound} path="**" />
          <Redirect to="**" />
        </Switch>
      </Router>
      <LoadingOverlay isLoading={isLoading} />
      <InstallAppButton />
    </>
  )
}

const App: React.FC = () => {
  return (
    <LoadingProvider delay={400}>
      <AppContent />
    </LoadingProvider>
  )
}

const container = document.getElementById('app')
if (!container) throw new Error('Failed to find the root element')
const root = createRoot(container)
root.render(<App />)

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // Evita romper la carga si el navegador bloquea el registro.
    })
  })
}
